import { Chip, ChipColor } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';
import { SsoConnectionStatus, statusContent } from './Types';

interface Props {
  status: SsoConnectionStatus;
}

const chipColor = (status: SsoConnectionStatus): ChipColor => {
  switch (statusContent(status).variant) {
    case 'green':
      return 'green';
    case 'amber':
      return 'amber';
    case 'neutral':
      return 'gray';
  }
};

const StatusChip: React.FC<Props> = ({ status }) => (
  <Chip color={chipColor(status)} size="sm" radius="full">
    <T kind={statusContent(status).label} />
  </Chip>
);

export default observer(StatusChip);
